import { Component, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-list-title',
  templateUrl: './title.component.html',
  host: {
    class: 'uex-list-title'
  }
})
export class ListTitleComponent implements OnInit {
  constructor() { }

  public ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-list-title]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-list-title'
  }
})
export class ListHeadingTitleComponent {
  constructor() { }
}
